import { Validator } from "../validator"

enum NameError {
    EMPTY = `errors.required`,
    INVALID = `errors.invalid_name`
}

const PATTERN = /^[\p{L}\p{M} ,()/.@\-']+$/u
const NBSP = /%E2%80%86/g

class NameValidator implements Validator<string, NameError> {
    validate(entry: string): NameError | undefined {
        if (entry === ``) {
            return NameError.EMPTY
        }
        if (!PATTERN.test(entry)) {
            return NameError.INVALID
        }
        if (entry && NBSP.test(encodeURIComponent(entry))) {
            return NameError.INVALID
        }
    }
}

export default NameValidator
export { NameError }
